import React from "react";

/**
 * iter239 (F14) — Route/component failure containment.
 * A single subtree render error must not blank the entire ERP shell.
 * The error is logged; a small compact recovery panel is shown in place.
 * The rest of the app (header, sidebar, other routes) keeps working.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", err, info && info.componentStack);
  }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="m-6 p-4 rounded-lg border border-red-200 bg-red-50 dark:bg-red-500/10 dark:border-red-500/30">
        <div className="text-sm font-semibold text-red-800 dark:text-red-300">
          Bir hata oluştu — sayfa geçici olarak yüklenemedi.
        </div>
        <div className="text-xs text-red-700 dark:text-red-300/80 mt-1 font-mono break-words">
          {String(this.state.err && this.state.err.message || this.state.err)}
        </div>
        <button
          onClick={() => this.setState({ err: null })}
          className="mt-3 text-xs bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
          data-testid="error-boundary-retry"
        >
          Tekrar Dene
        </button>
      </div>
    );
  }
}
